"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelsAI = void 0;
const modelsAIPostValuatorModelsSaleValuationPost_js_1 = require("../funcs/modelsAIPostValuatorModelsSaleValuationPost.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class ModelsAI extends sdks_js_1.ClientSDK {
    /**
     * Post Valuator
     *
     * @remarks
     * Get an updated property sale value based on a corrected property type and/or number of bedrooms.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
     * with details why they are not valid.
     *
     * | Parameter                       | Description                                                                                                    |
     * |:--------------------------------|:---------------------------------------------------------------------------------------------------------------|
     * | `street_group_property_id`      | The unique identifier associated with the property request                                                     |
     * </details>
     *
     * ## Responses
     *
     * <details>
     * <summary>Click to view information on the responses for this endpoint</summary>
     *
     * The function uses the `street_group_property_id` to fetch the remaining property details and then calculates the sale value based on the corrected property type and number of bedrooms.
     *
     * | Status        | Description                                                                                                                  |
     * | :------------ | :--------------------------------------------------------------------------------------------------------------------------- |
     * | 200 OK        | Returned if the property has an estimated sale value.                                                                        |
     * | 404 Not Found | Returned if the `street_group_property_id` wasn't matched to a property or if there wasn't enough data to make a prediction. |
     *
     * </details>
     */
    async postValuatorModelsSaleValuationPost(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, modelsAIPostValuatorModelsSaleValuationPost_js_1.modelsAIPostValuatorModelsSaleValuationPost)(this, security, request, options));
    }
}
exports.ModelsAI = ModelsAI;
//# sourceMappingURL=modelsai.js.map